export default `<svg
  width="429"
  height="100"
  viewBox="0 0 429 100"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <g opacity="0.6" filter="url(#filter0_i_907_33313)">
    <g clip-path="url(#clip0_907_33313)">
      <rect
        x="0.624512"
        y="30"
        width="40"
        height="40"
        rx="6.06061"
        fill="#F8F8F8"
      />
      <g filter="url(#filter1_d_907_33313)">
        <rect
          x="2.44263"
          y="31.8181"
          width="36.3636"
          height="36.3636"
          rx="3.96118"
          fill="url(#paint0_linear_907_33313)"
        />
        <rect
          x="2.59414"
          y="31.9697"
          width="36.0606"
          height="36.0606"
          rx="3.80966"
          stroke="#E4E4E4"
          stroke-width="0.30303"
        />
        <g filter="url(#filter2_i_907_33313)">
          <path
            d="M29.8023 40H20.1707C20.1707 42.4001 22.1166 44.346 24.5167 44.346H26.2905V46.0605C26.2925 48.4552 28.2311 50.3965 30.6238 50.4031H30.6245V40.8383C30.6245 40.8369 30.6245 40.8363 30.6245 40.8349C30.6245 40.3781 30.2577 40.0073 29.8029 40.0007H29.8023V40ZM25.0368 44.7974H15.4053C15.4059 47.1975 17.3512 49.1427 19.7512 49.1427H21.5251V50.8579C21.5271 53.2573 23.4717 55.2012 25.8711 55.2032V45.6324C25.8711 45.1716 25.4976 44.7981 25.0368 44.7981V44.7974ZM20.2674 49.5942H10.6245C10.6258 51.9949 12.5724 53.9402 14.9731 53.9402C14.9772 53.9402 14.9812 53.9402 14.9852 53.9402H16.7597V55.654C16.7597 58.0534 18.7043 59.9987 21.1037 60V50.4318C21.1037 49.969 20.7289 49.5942 20.2661 49.5942H20.2674Z"
            fill="#E2E5E6"
          />
        </g>
      </g>
    </g>
  </g>
  <g opacity="0.8" filter="url(#filter3_i_907_33313)">
    <g clip-path="url(#clip1_907_33313)">
      <rect
        x="72.6245"
        y="20"
        width="60"
        height="60"
        rx="9.09091"
        fill="#F8F8F8"
      />
      <g filter="url(#filter4_d_907_33313)">
        <rect
          x="75.3518"
          y="22.7272"
          width="54.5455"
          height="54.5455"
          rx="5.94177"
          fill="url(#paint1_linear_907_33313)"
        />
        <rect
          x="75.5791"
          y="22.9545"
          width="54.0909"
          height="54.0909"
          rx="5.7145"
          stroke="#E4E4E4"
          stroke-width="0.454545"
        />
        <g filter="url(#filter5_i_907_33313)">
          <path
            d="M107.82 46.3182H101.633V34.25H107.82C111.159 34.25 113.875 36.9563 113.875 40.2834C113.875 43.6105 111.159 46.3182 107.82 46.3182ZM103.617 44.3415H107.82C110.065 44.3415 111.891 42.5208 111.891 40.2848C111.891 38.0488 110.064 36.228 107.82 36.228H103.617V44.3415ZM103.617 46.3182H97.4309C94.092 46.3182 91.3761 43.6119 91.3761 40.2848C91.3761 36.9576 94.092 34.25 97.4309 34.25H103.618V46.3182H103.617ZM97.4309 36.2266C95.1857 36.2266 93.3598 38.0474 93.3598 40.2834C93.3598 42.5194 95.1857 44.3415 97.4309 44.3415H101.634V36.2266H97.4309ZM103.617 56.4084H97.4309C94.092 56.4084 91.3761 53.7021 91.3761 50.375C91.3761 47.0478 94.092 44.3415 97.4309 44.3415H103.618V56.4084H103.617ZM97.4309 46.3182C95.1857 46.3182 93.3598 48.139 93.3598 50.375C93.3598 52.611 95.187 54.4318 97.4309 54.4318H101.634V46.3182H97.4309ZM97.4633 66.5C94.1069 66.5 91.3748 63.7937 91.3748 60.4665C91.3748 57.1394 94.0907 54.4331 97.4296 54.4331H103.617V60.4007C103.617 63.7641 100.856 66.5 97.4633 66.5ZM97.4309 56.4084C96.3516 56.4098 95.317 56.8377 94.5538 57.5982C93.7906 58.3587 93.3612 59.3897 93.3598 60.4652C93.3598 62.7025 95.2005 64.522 97.4647 64.522C99.7639 64.522 101.636 62.673 101.636 60.3993V56.4084H97.4309ZM107.82 56.4084H107.688C104.349 56.4084 101.633 53.7021 101.633 50.375C101.633 47.0478 104.349 44.3415 107.688 44.3415H107.82C111.159 44.3415 113.875 47.0478 113.875 50.375C113.875 53.7021 111.159 56.4084 107.82 56.4084ZM107.689 46.3182C105.444 46.3182 103.618 48.139 103.618 50.375C103.618 52.611 105.445 54.4318 107.689 54.4318H107.821C110.067 54.4318 111.892 52.611 111.892 50.375C111.892 48.139 110.064 46.3182 107.82 46.3182H107.689Z"
            fill="black"
          />
          <path
            d="M107.82 46.3182H101.633V34.25H107.82C111.159 34.25 113.875 36.9563 113.875 40.2834C113.875 43.6105 111.159 46.3182 107.82 46.3182ZM103.617 44.3415H107.82C110.065 44.3415 111.891 42.5208 111.891 40.2848C111.891 38.0488 110.064 36.228 107.82 36.228H103.617V44.3415ZM103.617 46.3182H97.4309C94.092 46.3182 91.3761 43.6119 91.3761 40.2848C91.3761 36.9576 94.092 34.25 97.4309 34.25H103.618V46.3182H103.617ZM97.4309 36.2266C95.1857 36.2266 93.3598 38.0474 93.3598 40.2834C93.3598 42.5194 95.1857 44.3415 97.4309 44.3415H101.634V36.2266H97.4309ZM103.617 56.4084H97.4309C94.092 56.4084 91.3761 53.7021 91.3761 50.375C91.3761 47.0478 94.092 44.3415 97.4309 44.3415H103.618V56.4084H103.617ZM97.4309 46.3182C95.1857 46.3182 93.3598 48.139 93.3598 50.375C93.3598 52.611 95.187 54.4318 97.4309 54.4318H101.634V46.3182H97.4309ZM97.4633 66.5C94.1069 66.5 91.3748 63.7937 91.3748 60.4665C91.3748 57.1394 94.0907 54.4331 97.4296 54.4331H103.617V60.4007C103.617 63.7641 100.856 66.5 97.4633 66.5ZM97.4309 56.4084C96.3516 56.4098 95.317 56.8377 94.5538 57.5982C93.7906 58.3587 93.3612 59.3897 93.3598 60.4652C93.3598 62.7025 95.2005 64.522 97.4647 64.522C99.7639 64.522 101.636 62.673 101.636 60.3993V56.4084H97.4309ZM107.82 56.4084H107.688C104.349 56.4084 101.633 53.7021 101.633 50.375C101.633 47.0478 104.349 44.3415 107.688 44.3415H107.82C111.159 44.3415 113.875 47.0478 113.875 50.375C113.875 53.7021 111.159 56.4084 107.82 56.4084ZM107.689 46.3182C105.444 46.3182 103.618 48.139 103.618 50.375C103.618 52.611 105.445 54.4318 107.689 54.4318H107.821C110.067 54.4318 111.892 52.611 111.892 50.375C111.892 48.139 110.064 46.3182 107.82 46.3182H107.689Z"
            fill="#E2E5E6"
          />
        </g>
      </g>
    </g>
  </g>
  <g filter="url(#filter6_i_907_33313)">
    <g clip-path="url(#clip2_907_33313)">
      <rect x="164.625" width="100" height="100" rx="15.1515" fill="#F8F8F8" />
      <g filter="url(#filter7_d_907_33313)">
        <rect
          x="169.17"
          y="4.54544"
          width="90.9091"
          height="90.9091"
          rx="9.90295"
          fill="url(#paint2_linear_907_33313)"
        />
        <rect
          x="169.549"
          y="4.92423"
          width="90.1515"
          height="90.1515"
          rx="9.52416"
          stroke="#E4E4E4"
          stroke-width="0.757576"
        />
        <g filter="url(#filter8_i_907_33313)">
          <path
            d="M194.542 40.5226C194.542 38.6884 195.271 36.9293 196.568 35.6323C197.865 34.3353 199.624 33.6066 201.458 33.6066H208.036C208.72 33.6066 209.142 32.8943 208.879 32.2626C208.747 31.9521 208.642 31.6304 208.566 31.3013C207.803 27.8733 210.392 24.3853 214.138 24.3853C217.886 24.3853 220.473 27.8733 219.71 31.3013C219.634 31.6304 219.529 31.9521 219.396 32.2626C219.131 32.8943 219.555 33.6066 220.24 33.6066H224.512C226.346 33.6066 228.105 34.3353 229.402 35.6323C230.699 36.9293 231.428 38.6884 231.428 40.5226V44.7944C231.428 45.4791 232.138 45.9009 232.772 45.6381C233.083 45.509 233.401 45.3984 233.733 45.3246C237.161 44.5615 240.649 47.1481 240.649 50.8966C240.649 54.645 237.161 57.2316 233.733 56.4686C233.404 56.3927 233.082 56.2878 232.772 56.155C232.14 55.8899 231.428 56.3141 231.428 56.9988V63.5759C231.428 65.4101 230.699 67.1692 229.402 68.4662C228.105 69.7632 226.346 70.4919 224.512 70.4919H220.148C219.484 70.4919 219.057 69.821 219.249 69.1871C219.343 68.8643 219.415 68.5323 219.445 68.1865C219.506 67.4524 219.414 66.7136 219.175 66.0168C218.936 65.3199 218.556 64.6802 218.057 64.1381C217.558 63.596 216.952 63.1633 216.278 62.8673C215.603 62.5713 214.874 62.4184 214.138 62.4184C213.401 62.4184 212.672 62.5713 211.998 62.8673C211.323 63.1633 210.718 63.596 210.219 64.1381C209.72 64.6802 209.339 65.3199 209.1 66.0168C208.861 66.7136 208.77 67.4524 208.831 68.1865C208.861 68.5323 208.932 68.8643 209.029 69.1871C209.218 69.821 208.792 70.4919 208.13 70.4919H201.458C199.624 70.4919 197.865 69.7632 196.568 68.4662C195.271 67.1692 194.542 65.4101 194.542 63.5759V56.9066C194.542 56.2426 195.213 55.8162 195.847 56.0075C196.17 56.102 196.502 56.1735 196.848 56.2034C197.582 56.2647 198.321 56.173 199.018 55.9341C199.714 55.6952 200.354 55.3143 200.896 54.8156C201.438 54.3168 201.871 53.711 202.167 53.0364C202.463 52.3619 202.616 51.6332 202.616 50.8966C202.616 50.1599 202.463 49.4313 202.167 48.7567C201.871 48.0822 201.438 47.4764 200.896 46.9776C200.354 46.4788 199.714 46.098 199.018 45.8591C198.321 45.6202 197.582 45.5285 196.848 45.5897C196.502 45.6197 196.17 45.6912 195.847 45.788C195.213 45.977 194.542 45.5505 194.542 44.8889V40.5226Z"
            fill="#DEE2E3"
          />
        </g>
      </g>
    </g>
  </g>
  <g opacity="0.8" filter="url(#filter9_i_907_33313)">
    <g clip-path="url(#clip3_907_33313)">
      <rect
        x="296.625"
        y="20"
        width="60"
        height="60"
        rx="9.09091"
        fill="#F8F8F8"
      />
      <g filter="url(#filter10_d_907_33313)">
        <rect
          x="299.352"
          y="22.7272"
          width="54.5455"
          height="54.5455"
          rx="5.94177"
          fill="url(#paint3_linear_907_33313)"
        />
        <rect
          x="299.579"
          y="22.9545"
          width="54.0909"
          height="54.0909"
          rx="5.7145"
          stroke="#E4E4E4"
          stroke-width="0.454545"
        />
        <g
          clip-path="url(#clip4_907_33313)"
          filter="url(#filter11_i_907_33313)"
        >
          <path
            d="M326.658 32.0132C316.708 32.0132 308.638 40.0817 308.638 50.0332C308.638 57.995 313.801 64.7495 320.962 67.1327C321.862 67.2994 322.153 66.7407 322.153 66.2662V62.9115C317.14 64.0017 316.097 60.7851 316.097 60.7851C315.277 58.7023 314.095 58.1482 314.095 58.1482C312.46 57.0295 314.22 57.0535 314.22 57.0535C316.029 57.1796 316.981 58.9111 316.981 58.9111C318.588 61.6651 321.196 60.8692 322.225 60.4082C322.386 59.2444 322.853 58.4485 323.369 57.9995C319.367 57.5415 315.16 55.9963 315.16 49.0932C315.16 47.1245 315.864 45.5177 317.016 44.2563C316.83 43.8013 316.212 41.9678 317.191 39.487C317.191 39.487 318.705 39.0035 322.148 41.3341C323.586 40.9346 325.126 40.7349 326.658 40.7274C328.19 40.7349 329.732 40.9346 331.172 41.3341C334.612 39.0035 336.123 39.487 336.123 39.487C337.103 41.9693 336.486 43.8028 336.3 44.2563C337.456 45.5177 338.155 47.126 338.155 49.0932C338.155 56.0143 333.939 57.5385 329.927 57.9845C330.573 58.5432 331.163 59.6394 331.163 61.3212V66.2662C331.163 66.7452 331.451 67.3084 332.366 67.1312C339.521 64.745 344.678 57.992 344.678 50.0332C344.678 40.0817 336.609 32.0132 326.658 32.0132Z"
            fill="#E2E5E6"
          />
        </g>
      </g>
    </g>
  </g>
  <g opacity="0.6" filter="url(#filter12_i_907_33313)">
    <g clip-path="url(#clip5_907_33313)">
      <rect
        x="388.625"
        y="30"
        width="40"
        height="40"
        rx="6.06061"
        fill="#F8F8F8"
      />
      <g filter="url(#filter13_d_907_33313)">
        <rect
          x="390.443"
          y="31.8181"
          width="36.3636"
          height="36.3636"
          rx="3.96118"
          fill="url(#paint4_linear_907_33313)"
        />
        <rect
          x="390.594"
          y="31.9697"
          width="36.0606"
          height="36.0606"
          rx="3.80966"
          stroke="#E4E4E4"
          stroke-width="0.30303"
        />
        <g filter="url(#filter14_i_907_33313)">
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M414.974 43.636C411.473 40.135 405.805 40.1214 402.287 43.5952L415.015 56.3228C418.489 52.8049 418.475 47.1371 414.974 43.636ZM400.492 46.1099L412.5 58.1186C413.123 57.8201 413.719 57.4458 414.274 56.9956L401.615 44.3365C401.165 44.8912 400.79 45.487 400.492 46.1099ZM409.117 58.9858L399.625 49.4938C399.67 48.6883 399.822 47.8877 400.083 47.1155L411.495 58.5273C410.723 58.7879 409.922 58.9407 409.117 58.9858ZM402.246 56.364C400.729 54.8468 399.867 52.9227 399.66 50.9431L407.667 58.9508C405.688 58.7434 403.763 57.8811 402.246 56.364Z"
            fill="#DEE2E3"
          />
        </g>
      </g>
    </g>
  </g>
  <defs>
    <filter
      id="filter0_i_907_33313"
      x="0.624512"
      y="29.798"
      width="40"
      height="40.202"
      filterUnits="userSpaceOnUse"
      color-interpolation-filters="sRGB"
    >
      <feFlood flood-opacity="0" result="BackgroundImageFix" />
      <feBlend
        mode="normal"
        in="SourceGraphic"
        in2="BackgroundImageFix"
        result="shape"
      />
      <feColorMatrix
        in="SourceAlpha"
        type="matrix"
        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        result="hardAlpha"
      />
      <feOffset dy="-0.20202" />
      <feGaussianBlur stdDeviation="0.707071" />
      <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
      <feColorMatrix
        type="matrix"
        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
      />
      <feBlend
        mode="normal"
        in2="shape"
        result="effect1_innerShadow_907_33313"
      />
    </filter>
    <filter
      id="filter1_d_907_33313"
      x="0.927476"
      y="30.808"
      width="39.3938"
      height="39.394"
      filterUnits="userSpaceOnUse"
      color-interpolation-filters="sRGB"
    >
      <feFlood flood-opacity="0" result="BackgroundImageFix" />
      <feColorMatrix
        in="SourceAlpha"
        type="matrix"
        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        result="hardAlpha"
      />
      <feOffset dy="0.505051" />
      <feGaussianBlur stdDeviation="0.757576" />
      <feComposite in2="hardAlpha" operator="out" />
      <feColorMatrix
        type="matrix"
        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
      />
      <feBlend
        mode="normal"
        in2="BackgroundImageFix"
        result="effect1_dropShadow_907_33313"
      />
      <feBlend
        mode="normal"
        in="SourceGraphic"
        in2="effect1_dropShadow_907_33313"
        result="shape"
      />
    </filter>
    <filter
      id="filter2_i_907_33313"
      x="8.6333"
      y="38.0088"
      width="24.2725"
      height="24.2725"
      filterUnits="userSpaceOnUse"
      color-interpolation-filters="sRGB"
    >
      <feFlood flood-opacity="0" result="BackgroundImageFix" />
      <feBlend
        mode="normal"
        in="SourceGraphic"
        in2="BackgroundImageFix"
        result="shape"
      />
      <feColorMatrix
        in="SourceAlpha"
        type="matrix"
        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        result="hardAlpha"
      />
      <feOffset dx="0.245902" dy="0.245902" />
      <feGaussianBlur stdDeviation="0.327869" />
      <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
      <feColorMatrix
        type="matrix"
        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
      />
      <feBlend
        mode="normal"
        in2="shape"
        result="effect1_innerShadow_907_33313"
      />
    </filter>
    <filter
      id="filter3_i_907_33313"
      x="72.6245"
      y="19.697"
      width="60"
      height="60.303"
      filterUnits="userSpaceOnUse"
      color-interpolation-filters="sRGB"
    >
      <feFlood flood-opacity="0" result="BackgroundImageFix" />
      <feBlend
        mode="normal"
        in="SourceGraphic"
        in2="BackgroundImageFix"
        result="shape"
      />
      <feColorMatrix
        in="SourceAlpha"
        type="matrix"
        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        result="hardAlpha"
      />
      <feOffset dy="-0.30303" />
      <feGaussianBlur stdDeviation="1.06061" />
      <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
      <feColorMatrix
        type="matrix"
        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
      />
      <feBlend
        mode="normal"
        in2="shape"
        result="effect1_innerShadow_907_33313"
      />
    </filter>
    <filter
      id="filter4_d_907_33313"
      x="73.0791"
      y="21.2121"
      width="59.0909"
      height="59.0909"
      filterUnits="userSpaceOnUse"
      color-interpolation-filters="sRGB"
    >
      <feFlood flood-opacity="0" result="BackgroundImageFix" />
      <feColorMatrix
        in="SourceAlpha"
        type="matrix"
        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        result="hardAlpha"
      />
      <feOffset dy="0.757576" />
      <feGaussianBlur stdDeviation="1.13636" />
      <feComposite in2="hardAlpha" operator="out" />
      <feColorMatrix
        type="matrix"
        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
      />
      <feBlend
        mode="normal"
        in2="BackgroundImageFix"
        result="effect1_dropShadow_907_33313"
      />
      <feBlend
        mode="normal"
        in="SourceGraphic"
        in2="effect1_dropShadow_907_33313"
        result="shape"
      />
    </filter>
    <filter
      id="filter5_i_907_33313"
      x="84.6379"
      y="32.0132"
      width="36.4089"
      height="36.4088"
      filterUnits="userSpaceOnUse"
      color-interpolation-filters="sRGB"
    >
      <feFlood flood-opacity="0" result="BackgroundImageFix" />
      <feBlend
        mode="normal"
        in="SourceGraphic"
        in2="BackgroundImageFix"
        result="shape"
      />
      <feColorMatrix
        in="SourceAlpha"
        type="matrix"
        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        result="hardAlpha"
      />
      <feOffset dx="0.368852" dy="0.368852" />
      <feGaussianBlur stdDeviation="0.491803" />
      <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
      <feColorMatrix
        type="matrix"
        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
      />
      <feBlend
        mode="normal"
        in2="shape"
        result="effect1_innerShadow_907_33313"
      />
    </filter>
    <filter
      id="filter6_i_907_33313"
      x="164.625"
      y="-0.50505"
      width="100"
      height="100.505"
      filterUnits="userSpaceOnUse"
      color-interpolation-filters="sRGB"
    >
      <feFlood flood-opacity="0" result="BackgroundImageFix" />
      <feBlend
        mode="normal"
        in="SourceGraphic"
        in2="BackgroundImageFix"
        result="shape"
      />
      <feColorMatrix
        in="SourceAlpha"
        type="matrix"
        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        result="hardAlpha"
      />
      <feOffset dy="-0.50505" />
      <feGaussianBlur stdDeviation="1.76768" />
      <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
      <feColorMatrix
        type="matrix"
        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
      />
      <feBlend
        mode="normal"
        in2="shape"
        result="effect1_innerShadow_907_33313"
      />
    </filter>
    <filter
      id="filter7_d_907_33313"
      x="165.382"
      y="2.02019"
      width="98.4849"
      height="98.4848"
      filterUnits="userSpaceOnUse"
      color-interpolation-filters="sRGB"
    >
      <feFlood flood-opacity="0" result="BackgroundImageFix" />
      <feColorMatrix
        in="SourceAlpha"
        type="matrix"
        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        result="hardAlpha"
      />
      <feOffset dy="1.26263" />
      <feGaussianBlur stdDeviation="1.89394" />
      <feComposite in2="hardAlpha" operator="out" />
      <feColorMatrix
        type="matrix"
        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
      />
      <feBlend
        mode="normal"
        in2="BackgroundImageFix"
        result="effect1_dropShadow_907_33313"
      />
      <feBlend
        mode="normal"
        in="SourceGraphic"
        in2="effect1_dropShadow_907_33313"
        result="shape"
      />
    </filter>
    <filter
      id="filter8_i_907_33313"
      x="194.542"
      y="24.3853"
      width="46.7212"
      height="46.7213"
      filterUnits="userSpaceOnUse"
      color-interpolation-filters="sRGB"
    >
      <feFlood flood-opacity="0" result="BackgroundImageFix" />
      <feBlend
        mode="normal"
        in="SourceGraphic"
        in2="BackgroundImageFix"
        result="shape"
      />
      <feColorMatrix
        in="SourceAlpha"
        type="matrix"
        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        result="hardAlpha"
      />
      <feOffset dx="0.614754" dy="0.614754" />
      <feGaussianBlur stdDeviation="0.819672" />
      <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
      <feColorMatrix
        type="matrix"
        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
      />
      <feBlend
        mode="normal"
        in2="shape"
        result="effect1_innerShadow_907_33313"
      />
    </filter>
    <filter
      id="filter9_i_907_33313"
      x="296.625"
      y="19.697"
      width="60"
      height="60.303"
      filterUnits="userSpaceOnUse"
      color-interpolation-filters="sRGB"
    >
      <feFlood flood-opacity="0" result="BackgroundImageFix" />
      <feBlend
        mode="normal"
        in="SourceGraphic"
        in2="BackgroundImageFix"
        result="shape"
      />
      <feColorMatrix
        in="SourceAlpha"
        type="matrix"
        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        result="hardAlpha"
      />
      <feOffset dy="-0.30303" />
      <feGaussianBlur stdDeviation="1.06061" />
      <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
      <feColorMatrix
        type="matrix"
        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
      />
      <feBlend
        mode="normal"
        in2="shape"
        result="effect1_innerShadow_907_33313"
      />
    </filter>
    <filter
      id="filter10_d_907_33313"
      x="297.079"
      y="21.2121"
      width="59.0909"
      height="59.0909"
      filterUnits="userSpaceOnUse"
      color-interpolation-filters="sRGB"
    >
      <feFlood flood-opacity="0" result="BackgroundImageFix" />
      <feColorMatrix
        in="SourceAlpha"
        type="matrix"
        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        result="hardAlpha"
      />
      <feOffset dy="0.757576" />
      <feGaussianBlur stdDeviation="1.13636" />
      <feComposite in2="hardAlpha" operator="out" />
      <feColorMatrix
        type="matrix"
        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
      />
      <feBlend
        mode="normal"
        in2="BackgroundImageFix"
        result="effect1_dropShadow_907_33313"
      />
      <feBlend
        mode="normal"
        in="SourceGraphic"
        in2="effect1_dropShadow_907_33313"
        result="shape"
      />
    </filter>
    <filter
      id="filter11_i_907_33313"
      x="308.638"
      y="32.0132"
      width="36.4089"
      height="36.4088"
      filterUnits="userSpaceOnUse"
      color-interpolation-filters="sRGB"
    >
      <feFlood flood-opacity="0" result="BackgroundImageFix" />
      <feBlend
        mode="normal"
        in="SourceGraphic"
        in2="BackgroundImageFix"
        result="shape"
      />
      <feColorMatrix
        in="SourceAlpha"
        type="matrix"
        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        result="hardAlpha"
      />
      <feOffset dx="0.368852" dy="0.368852" />
      <feGaussianBlur stdDeviation="0.491803" />
      <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
      <feColorMatrix
        type="matrix"
        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
      />
      <feBlend
        mode="normal"
        in2="shape"
        result="effect1_innerShadow_907_33313"
      />
    </filter>
    <filter
      id="filter12_i_907_33313"
      x="388.625"
      y="29.798"
      width="40"
      height="40.202"
      filterUnits="userSpaceOnUse"
      color-interpolation-filters="sRGB"
    >
      <feFlood flood-opacity="0" result="BackgroundImageFix" />
      <feBlend
        mode="normal"
        in="SourceGraphic"
        in2="BackgroundImageFix"
        result="shape"
      />
      <feColorMatrix
        in="SourceAlpha"
        type="matrix"
        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        result="hardAlpha"
      />
      <feOffset dy="-0.20202" />
      <feGaussianBlur stdDeviation="0.707071" />
      <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
      <feColorMatrix
        type="matrix"
        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
      />
      <feBlend
        mode="normal"
        in2="shape"
        result="effect1_innerShadow_907_33313"
      />
    </filter>
    <filter
      id="filter13_d_907_33313"
      x="388.927"
      y="30.808"
      width="39.3938"
      height="39.394"
      filterUnits="userSpaceOnUse"
      color-interpolation-filters="sRGB"
    >
      <feFlood flood-opacity="0" result="BackgroundImageFix" />
      <feColorMatrix
        in="SourceAlpha"
        type="matrix"
        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        result="hardAlpha"
      />
      <feOffset dy="0.505051" />
      <feGaussianBlur stdDeviation="0.757576" />
      <feComposite in2="hardAlpha" operator="out" />
      <feColorMatrix
        type="matrix"
        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
      />
      <feBlend
        mode="normal"
        in2="BackgroundImageFix"
        result="effect1_dropShadow_907_33313"
      />
      <feBlend
        mode="normal"
        in="SourceGraphic"
        in2="effect1_dropShadow_907_33313"
        result="shape"
      />
    </filter>
    <filter
      id="filter14_i_907_33313"
      x="396.633"
      y="38.0088"
      width="24.2725"
      height="24.2725"
      filterUnits="userSpaceOnUse"
      color-interpolation-filters="sRGB"
    >
      <feFlood flood-opacity="0" result="BackgroundImageFix" />
      <feBlend
        mode="normal"
        in="SourceGraphic"
        in2="BackgroundImageFix"
        result="shape"
      />
      <feColorMatrix
        in="SourceAlpha"
        type="matrix"
        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        result="hardAlpha"
      />
      <feOffset dx="0.245902" dy="0.245902" />
      <feGaussianBlur stdDeviation="0.327869" />
      <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
      <feColorMatrix
        type="matrix"
        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
      />
      <feBlend
        mode="normal"
        in2="shape"
        result="effect1_innerShadow_907_33313"
      />
    </filter>
    <linearGradient
      id="paint0_linear_907_33313"
      x1="7.49313"
      y1="32.5757"
      x2="28.8063"
      y2="68.6363"
      gradientUnits="userSpaceOnUse"
    >
      <stop stop-color="#F8F8F8" />
      <stop offset="0.348555" stop-color="white" />
      <stop offset="0.672956" stop-color="white" />
      <stop offset="1" stop-color="#FAFAFA" />
      <stop offset="1" stop-color="#F8F8F8" />
    </linearGradient>
    <linearGradient
      id="paint1_linear_907_33313"
      x1="82.9276"
      y1="23.8636"
      x2="114.897"
      y2="77.9545"
      gradientUnits="userSpaceOnUse"
    >
      <stop stop-color="#F8F8F8" />
      <stop offset="0.348555" stop-color="white" />
      <stop offset="0.672956" stop-color="white" />
      <stop offset="1" stop-color="#FAFAFA" />
      <stop offset="1" stop-color="#F8F8F8" />
    </linearGradient>
    <linearGradient
      id="paint2_linear_907_33313"
      x1="181.796"
      y1="6.43938"
      x2="235.079"
      y2="96.5909"
      gradientUnits="userSpaceOnUse"
    >
      <stop stop-color="#F8F8F8" />
      <stop offset="0.348555" stop-color="white" />
      <stop offset="0.672956" stop-color="white" />
      <stop offset="1" stop-color="#FAFAFA" />
      <stop offset="1" stop-color="#F8F8F8" />
    </linearGradient>
    <linearGradient
      id="paint3_linear_907_33313"
      x1="306.928"
      y1="23.8636"
      x2="338.897"
      y2="77.9545"
      gradientUnits="userSpaceOnUse"
    >
      <stop stop-color="#F8F8F8" />
      <stop offset="0.348555" stop-color="white" />
      <stop offset="0.672956" stop-color="white" />
      <stop offset="1" stop-color="#FAFAFA" />
      <stop offset="1" stop-color="#F8F8F8" />
    </linearGradient>
    <linearGradient
      id="paint4_linear_907_33313"
      x1="395.493"
      y1="32.5757"
      x2="416.806"
      y2="68.6363"
      gradientUnits="userSpaceOnUse"
    >
      <stop stop-color="#F8F8F8" />
      <stop offset="0.348555" stop-color="white" />
      <stop offset="0.672956" stop-color="white" />
      <stop offset="1" stop-color="#FAFAFA" />
      <stop offset="1" stop-color="#F8F8F8" />
    </linearGradient>
    <clipPath id="clip0_907_33313">
      <rect
        x="0.624512"
        y="30"
        width="40"
        height="40"
        rx="6.06061"
        fill="white"
      />
    </clipPath>
    <clipPath id="clip1_907_33313">
      <rect
        x="72.6245"
        y="20"
        width="60"
        height="60"
        rx="9.09091"
        fill="white"
      />
    </clipPath>
    <clipPath id="clip2_907_33313">
      <rect x="164.625" width="100" height="100" rx="15.1515" fill="white" />
    </clipPath>
    <clipPath id="clip3_907_33313">
      <rect
        x="296.625"
        y="20"
        width="60"
        height="60"
        rx="9.09091"
        fill="white"
      />
    </clipPath>
    <clipPath id="clip4_907_33313">
      <rect
        width="36.0399"
        height="36.0399"
        fill="white"
        transform="translate(308.638 32.0132)"
      />
    </clipPath>
    <clipPath id="clip5_907_33313">
      <rect
        x="388.625"
        y="30"
        width="40"
        height="40"
        rx="6.06061"
        fill="white"
      />
    </clipPath>
  </defs>
</svg>`;
